/** Tiny support amounts: 3 -> "3¢", 150 -> "$1.50". Rolls over at a dollar. */
export function cents(n: number): string {
  return n < 100 ? `${n}¢` : `$${(n / 100).toFixed(2)}`;
}

/** Compact follower/count formatting: 12400 -> "12.4K", 2_300_000 -> "2.3M". */
export function formatCount(n: number): string {
  if (n >= 1_000_000) return trim(n / 1_000_000) + 'M';
  if (n >= 1_000) return trim(n / 1_000) + 'K';
  return String(n);
}

function trim(n: number): string {
  // One decimal, but drop a trailing ".0" (12.0K -> 12K)
  return n.toFixed(1).replace(/\.0$/, '');
}
